import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 },
    noun: { type: String, default: 'items' },
    slowAfter: { type: Number, default: 90000 }
  }

  static targets = ['bar', 'label', 'hint']

  connect () {
    this.startedAt = Date.now()
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  async poll () {
    let data
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      if (!response.ok) return
      data = await response.json()
    } catch (_) {
      return
    }

    if (data.done) {
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    if (this.hasBarTarget) {
      this.barTarget.style.width = `${Math.max(data.percent, 5)}%`
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = data.total > 0
        ? `${data.built} of ${data.total} ${this.nounValue} built`
        : 'Starting…'
    }

    if (this.hasHintTarget && Date.now() - this.startedAt > this.slowAfterValue) {
      this.hintTarget.classList.remove('hidden')
    }
  }
}
